<template>
  <div>
    <doc-title :text="source.name" v-if="source"></doc-title>

    <h1 v-if="source">
      {{ source.name }}
    </h1>
    <hr>

    <post-list :resource="'sources/' + $route.params.id + '/posts'"></post-list>
  </div>
</template>

<script>
  import DocTitle from '@/vues/helpers/doc-title.vue';
  import PostList from '@/vues/posts/list.vue';

  export default {
    name: 'Source-Show',
    components: { DocTitle, PostList },
    data () {
      return {
        source: null
      };
    },
    watch: {
      async '$route.params.id' () {
        await this.load();
      }
    },
    async mounted () {
      await this.load();
    },
    methods: {
      async load () {
        const res = await this.$http.get('sources/' + this.$route.params.id);
        this.source = res.body;
      }
    }
  };
</script>
